import { css } from "@emotion/css";
import classNames from "classnames";
import { ReactNode } from "react";

import { Icon } from "../../../../foundations/icons/Icon/Icon";
import { Text } from "../../../../foundations/typography/Text";

const TYPES = {
  valid: {
    icon: "check_circle",
    iconColor: "icon-success",
    textColor: "text-success",
  },
  invalid: {
    icon: "error",
    iconColor: "icon-danger",
    textColor: "text-danger",
  },
} as const;

interface Props {
  id?: string;
  type?: "valid" | "invalid";
  className?: string;
  children?: ReactNode;
  testID?: string;
}

export function FormFeedback({
  id,
  type = "invalid",
  className,
  children,
  testID = "form-feedback",
}: Props) {
  if (!children) {
    return null;
  }
  const { icon, iconColor, textColor } = TYPES[type];

  return (
    <div
      className={classNames(
        "form-feedback",
        css({
          gap: "var(--space-1)",
          marginTop: "var(--space-1)",
          display: "flex",
          alignItems: "top",
        }),
        className
      )}
      data-testid={testID}
    >
      <Icon
        type="mini"
        name={icon}
        color={iconColor}
        size="space-4"
        padding="space-05"
      />
      <Text
        id={id}
        color={textColor}
        style="input/inline-error"
        aria-live="polite"
      >
        {children}
      </Text>
    </div>
  );
}
